export async function clearLocalStorage() {
  informClavoDomainIfLoggedIn(false)
  localStorage.clear()
}
export function informClavoDomainIfLoggedIn(loggedIn) {
  var frame = document.getElementsByTagName('iframe')[0]
  var win = frame.contentWindow
  win.postMessage(JSON.stringify({ loggedIn: loggedIn }), '*')
}
export async function getLocationsCached(team, fn) {
  let teamId = team.teamId
  let locationsCache
  let locationsCacheRaw

  try {
    locationsCacheRaw = localStorage.getItem('loc-' + teamId)
    if (locationsCacheRaw) {
      locationsCache = JSON.parse(locationsCacheRaw)
    }
  } catch (e) {
    locationsCache = undefined
  }

  if (locationsCache && !team.locationsUpdatedAt) {
    return locationsCache.locations
  }

  if (!locationsCache || locationsCache.locationsUpdatedAt !== team.locationsUpdatedAt.toJSON()) {
    let locationsParse = await fn(teamId)
    locationsCache = { locations: locationsParse.locations }
    locationsCache['locationsUpdatedAt'] = team.locationsUpdatedAt
    localStorage.setItem('loc-' + teamId, JSON.stringify(locationsCache))
    return locationsParse.locations
  }
  return locationsCache.locations
}
